import { Card, CardContent, CardHeader } from '@/app/common/components/Card.tsx'
import { Button } from '@/app/common/components/button/Button.tsx'
import Badge from '@/app/common/components/Badge'
import { useOutletContext } from 'react-router-dom'
import { ProgramPurseResource } from '@/queries/program_purses/schemas'

type Props = {
  onConfigure: () => void
}

interface OutletContext {
  purse: ProgramPurseResource
}

export default function SpecialNeedsAwardCard({ onConfigure }: Props) {
  const { purse } = useOutletContext<OutletContext>()

  const specialEducationModifiers =
    purse.distributions_rules.distribution_modifiers.filter(
      (modifier) => modifier.modifier_code === 'special_education'
    )
  const isActive = specialEducationModifiers.some(
    (modifier) => modifier.is_active
  )

  return (
    <Card>
      <CardHeader className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <div>
          <h3 className="text-base sm:text-lg font-semibold text-gray-900">
            Special Needs Additional Funding
          </h3>
          <p className="mt-1 text-sm text-gray-700">
            Configure supplemental award amounts for students with documented
            special needs.
          </p>
        </div>
        <Badge semanticColor={isActive ? 'Positive' : 'Negative'}>
          {isActive ? 'Active' : 'Inactive'}
        </Badge>
      </CardHeader>
      <CardContent>
        <Button variant="primary" size="sm" onClick={onConfigure}>
          Configure
        </Button>
      </CardContent>
    </Card>
  )
}
